<template lang="pug">

  transition(
    :css="false" 
    @enter="enter"
    @leave="leave" 
  )
 
    svg( 
      version="1.1"  
      xmlns="http://www.w3.org/2000/svg" 
      xmlns:xlink="http://www.w3.org/1999/xlink" 
      viewBox="0 0 1024 796.6" 
      enable-background="new 0 0 1024 796.6" 
      xml:space="preserve"
    ).menu
      
      line( 
        ref="line_one" 
        fill="none"  
        stroke-width="111" 
        stroke-linecap="round" 
        stroke-miterlimit="10" 
        x1="58.76" 
        y1="57.24" 
        x2="961.85" 
        y2="57.24"
        )

      line( 
        ref="line_two" 
        opacity="0.6" 
        fill="none"  
        stroke-width="111" 
        stroke-linecap="round" 
        stroke-miterlimit="10" 
        x1="58.76" 
        y1="393.45" 
        x2="961.85" 
        y2="393.45"
        ) 
      
      line( 
        ref="line_three" 
        opacity="0.3" 
        fill="none"  
        stroke-width="111" 
        stroke-linecap="round" 
        stroke-miterlimit="10" 
        x1="58.76" 
        y1="735.54" 
        x2="510.96" 
        y2="735.54"
        )

      

</template>

<script>

import gsap from 'gsap'
import { MODAL_STATES, PATHS } from 'src/config/app' 
import { mapState, mapMutations } from 'vuex'
import Env from 'src/config/env'  

export default {

  computed: {

    ...mapState('app', ['motion_clamp', 'modal_state']),
    
    isMenuOpen(){
      return (this.modal_state === MODAL_STATES.MENU)
    },

    isHomeRoute(){
      return this.$route.name === PATHS.HOME
    },
  },

  data() {
    return { 
      dir: -1
    }
  },

  components: { },

  methods: {

    mouseenter(){
 
      this.killTweens()

      gsap.to([
        this.$refs.line_one,
        this.$refs.line_two,
        this.$refs.line_three
      ], {
        duration: 1 * this.motion_clamp,
        stroke: '#282C68'
      }) 

      this.show(0)
    },

    mouseleave(delay = 0){

      this.killTweens()

      gsap.to([
        this.$refs.line_one,
        this.$refs.line_two,
        this.$refs.line_three
      ], {
        duration: 1 * this.motion_clamp,
        stroke: '#ffffff'
      }) 

      this.show(delay)
    },
    
    enter( el, done ){ 

      this.killTweens()

      const delay = (this.dir === -1 ? 1.3 : 0.25)
      this.show(delay)
      done()
    },

    show(delay){

      const fromX = 800 * this.dir
      const fromOrigin = this.dir === -1 ? '0% 50%' : '100% 50%'
      const from = {
        x: fromX,
        scaleX: 0.2,
        opacity: 0,
        //transformOrigin: fromOrigin
      }

      const ease = this.dir === -1 ? 'expo.out' : 'expo.inOut'
      const duration = 0.7  * this.motion_clamp

      gsap.fromTo(this.$refs.line_one,  from, {

        duration: duration,
        delay: delay * this.motion_clamp,

        x: 0,
        scaleX: 1,
        opacity: 1,
        ease: ease
      })

      gsap.fromTo(this.$refs.line_two, from, {

        duration: duration,
        delay: (delay + 0.2) * this.motion_clamp,

        x: 0,
        scaleX: 1,
        opacity: 0.6,
        ease: ease
      })

      gsap.fromTo(this.$refs.line_three, from, {

        duration: duration,
        delay: (delay + 0.4) * this.motion_clamp,

        x: 0,
        scaleX: 1,
        opacity:  0.3,
        ease: ease
      })

      this.dir = -1
    },

    leave( el, done ){ 

      this.killTweens()

      const clamp = ( this.isMenuOpen || !this.isHomeRoute ) ? 0 : 1 
      const delay = 0
      const duration = 1 * this.motion_clamp * clamp

      this.dir = ( this.isMenuOpen ) ? 1 : -1

      gsap.to(this.$refs.line_one, {

        duration: duration,
        delay: delay * this.motion_clamp,

        x: 800,
        scaleX: 0.2,
        opacity: 0,
        ease: 'expo.inOut',
        //transformOrigin: '100% 50%'
      })

      gsap.to(this.$refs.line_two, {

        duration: duration,
        delay: (delay + 0.2) * this.motion_clamp * clamp,

        x: 800,
        scaleX: 0.2,
        opacity: 0 ,
        ease: 'expo.inOut',
        //transformOrigin: '100% 50%'
      })

      gsap.to(this.$refs.line_three, {

        duration: duration,
        delay: (delay + 0.4) * this.motion_clamp * clamp,

        x: 800,
        scaleX: 0.2,
        opacity:  0 ,
        ease: 'expo.inOut',
        //transformOrigin: '100% 50%',
        onComplete: done
      }) 
    },

    killTweens(){

      gsap.killTweensOf([
        this.$refs.line_one,
        this.$refs.line_two, 
        this.$refs.line_three 
      ])
    }
  },

  watch: {}
}

</script>

<style lang="sass">
@import "src/styles/common.sass"
 



</style>
